import { render } from "./UsersByBeltsComponent.vue?vue&type=template&id=0a08b756&scoped=true&ts=true"
import script from "./UsersByBeltsComponent.vue?vue&type=script&lang=ts"
export * from "./UsersByBeltsComponent.vue?vue&type=script&lang=ts"

import "./UsersByBeltsComponent.vue?vue&type=style&index=0&id=0a08b756&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a08b756"]])

export default __exports__